import { Box, Stack, Typography } from "@mui/material";
import React, { Component } from "react";
import LoginBg from "../../resources/background-loginlayout-login.svg?url";
import SignupBg from "../../resources/background-loginlayout-signup.svg?url";
import CloseIcon from "../../resources/icons-close.svg";
import Logo from "../../resources/logo.svg?url";
import CobrandingLogo from "../../resources/olc-logo.svg?url";
import Alert from "../Alert";
import Button from "../buttons/Button";
import Dialog from "../dialogs/Dialog";
import LoadingBar from "../LoadingBar";

export default class LoginLayout extends Component<any, any> {
  static defaultProps = {
    loginMode: true,
  };

  constructor(props: any) {
    super(props);
    this.state = {
      showLearnMoreDialog: false,
    };
  }

  handleCloseLearnMoreDialog = () => {
    this.setState({ showLearnMoreDialog: false });
  };

  handleOpenLearnMoreDialog = () => {
    this.setState({ showLearnMoreDialog: true });
    this.props.onLearnMore?.();
  };

  /** Opens the "Learn more" dialog from outside the banner, e.g. a "Learn more" link in an error.
   * The dialog is only mounted while the OLC banner shows, so callers need `showOlcBanner` on. */
  openLearnMore() {
    this.handleOpenLearnMoreDialog();
  }

  render() {
    const {
      heading,
      text,
      children,
      loginMode,
      sx,
      loading,
      isCoBrandingMode,
      showOlcBranding,
      showOlcBanner = true,
      learnMoreContent,
      theme,
      beforeHeading,
    } = this.props;

    const { showLearnMoreDialog } = this.state;

    // OLC chrome (logo + "moved to Klayo" banner) shows in co-branding mode and,
    // on the main login page, for non-co-branding users too (via showOlcBranding).
    const showOlc = isCoBrandingMode || showOlcBranding;

    return (
      <Stack direction="row" sx={{ width: "100%", minHeight: "100vh", ...sx }}>
        <LoadingBar
          loading={loading}
          sx={{ zIndex: 99999, width: "100vw", position: "fixed" }}
        />
        <Box
          sx={{
            background: "white",
            width: { xs: "100vw", md: "560px" },
            padding: { xs: "24px", md: "40px 64px" },
            boxSizing: "border-box",
          }}
        >
          <Stack direction={"row"} justifyContent={"space-between"} gap={3}>
            <Stack sx={{ width: { xs: "67px", md: "89px" } }}>
              <img src={Logo} alt="Klayo" style={{ width: "100%" }} />
            </Stack>
            {showOlc && (
              <Stack sx={{ width: "130px", height: "60px" }}>
                <img
                  src={CobrandingLogo}
                  alt="Klayo"
                  style={{ width: "100%" }}
                />
              </Stack>
            )}
          </Stack>

          {showOlc && showOlcBanner && (
            <>
              <Alert
                severity="info"
                sx={{
                  "& .MuiAlert-icon": {
                    display: "none",
                  },
                  marginTop: "40px",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "500",
                    color: "var(--grey-gr-900)",
                  }}
                >
                  OLC learning has moved to Klayo.{" "}
                  <b
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={this.handleOpenLearnMoreDialog}
                  >
                    Learn more
                  </b>
                </Typography>
              </Alert>
              <Dialog
                open={showLearnMoreDialog}
                title={
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    gap={2}
                  >
                    <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                      OLC learning has moved to Klayo
                    </div>
                    <Button
                      icon={<CloseIcon />}
                      onClick={this.handleCloseLearnMoreDialog}
                      sx={{ display: { xs: "none", md: "block" } }}
                    />
                  </Stack>
                }
                onClose={this.handleCloseLearnMoreDialog}
                maxWidth="sm"
                theme={theme}
              >
                {learnMoreContent ?? (
                  <Typography variant="body1">
                    Your OLC learning is now delivered via Klayo. All your
                    training content and progress has been migrated to this
                    enhanced platform. Use your existing OLC email to log in.
                  </Typography>
                )}
              </Dialog>
            </>
          )}
          {beforeHeading}
          {heading && (
            <Typography
              variant="h1"
              sx={{
                fontFamily: "Inter",
                fontWeight: "bold",
                letterSpacing: "-1.5px",
                color: "var(--grey-gr-900)",
                fontSize: { xs: "24px", md: "36px" },
                marginTop: beforeHeading
                  ? { xs: "24px", md: "32px" }
                  : { xs: "30px", md: "40px" },
              }}
            >
              {heading}
            </Typography>
          )}
          {text && (
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Inter",
                fontWeight: "normal",
                lineHeight: "1.56",
                letterSpacing: "-0.2px",
                color: "var(--grey-gr-900)",
                fontSize: { xs: "16px", md: "18px" },
                overflowWrap: "break-word",
                marginTop: "12px",
              }}
            >
              {text}
            </Typography>
          )}
          <Box sx={{ margin: "24px 0" }}>{children}</Box>
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            backgroundImage: `url("${loginMode ? LoginBg : SignupBg}")`,
            backgroundPosition: "bottom right",
            backgroundSize: "cover",
            backgroundAttachment: "fixed",
          }}
        ></Box>
      </Stack>
    );
  }
}
